import { css } from '@emotion/react'
import { ScrollView, Stack } from '@nexans/react-ui-kit'
import { Outlet } from 'react-router-dom'

function AnonymousLayout() {
  return (
    <Stack css={styles.main} direction="horizontal">
      <ScrollView styleContainer={{ flex: 1, width: '100%' }}>
        <Outlet />
      </ScrollView>
    </Stack>
  )
}

const styles = {
  main: css({
    height: '100vh',
    width: '100vw',
    overflow: 'hidden',
    position: 'relative',
  }),
  landing: css({ height: '100%', objectFit: 'cover', borderRadius: 40 }),
}

export default AnonymousLayout
